import { Column } from "@/components/datatable/DataTable";

export type ColumnType = 'STRING'|'DATE'|'DATETIME'|'NUMBER'|'CURRENCY'|'BOOLEAN'|'CPF_CNPJ'|'NONE'|'CUSTOM';

export type OperatorData = {
    name: string;
    symbol: string;
}

export type FilterData = {
    column: Column;
    operator: OperatorData;
    value: string;
}

const STRING_OPERATORS: OperatorData[] = [
    { name: 'Contém', symbol: '==' },
    { name: 'Igual', symbol: '==' },
    { name: 'Diferente', symbol: '!=' }
  ];
  
  const NUMBER_OPERATORS: OperatorData[] = [
    { name: 'Igual', symbol: '==' },
    { name: 'Diferente', symbol: '!=' },
    { name: 'Maior', symbol: '=gt=' },
    { name: 'Menor', symbol: '=lt=' },
    { name: 'Maior ou igual', symbol: '=ge=' },
    { name: 'Menor ou igual', symbol: '=le=' }
  ];
  
  const DATE_OPERATORS: OperatorData[] = [
    { name: 'Igual', symbol: '==' },
    { name: 'Diferente', symbol: '!=' },
    { name: 'Maior', symbol: '=gt=' },
    { name: 'Menor', symbol: '=lt=' },
    { name: 'Maior ou igual', symbol: '=ge=' },
    { name: 'Menor ou igual', symbol: '=le=' }
  ];
  
  const DATETIME_OPERATORS: OperatorData[] = [
    { name: 'Maior', symbol: '=gt=' },
    { name: 'Menor', symbol: '=lt=' },
    { name: 'Maior ou igual', symbol: '=ge=' },
    { name: 'Menor ou igual', symbol: '=le=' }
  ];
  
  const BOOLEAN_OPERATORS: OperatorData[] = [
    { name: 'Igual', symbol: '==' },
    { name: 'Diferente', symbol: '!=' }
  ];

  const CUSTOM_OPERATORS: OperatorData[] = [{ name: 'Igual', symbol: '==' }];

  export const OPERATORS = {
    STRING: STRING_OPERATORS,
    NUMBER: NUMBER_OPERATORS,
    DATE: DATE_OPERATORS,
    DATETIME: DATETIME_OPERATORS,
    BOOLEAN: BOOLEAN_OPERATORS,
    CURRENCY: NUMBER_OPERATORS,
    CPF_CNPJ: STRING_OPERATORS,
    CUSTOM: CUSTOM_OPERATORS,
    NONE: []
};